<app-share-button ></app-share-button>
<div class="row">
    <div class="col-md-8 ScrollStyle-1">
        <div class="card crd p-3">
            <div class="row">
                <div class="col-md-10 col10 mt-2" (mouseover)="showpayment(true,'2')"
                    (mouseout)="showpayment(false,'2')" id="17">
                    <h2 >Payment QR </h2>
                </div>
                <div class="col-md-2 col2"><a href="javascript:void(0)" (click)="openShareOptions()"> <button class="btn share"><img src="./assets/share (5).svg" style="width: 30px;" (click)="menues('share-button')"
                    alt=""> </button> </a> 
                </div>
                <!-- <div class="col-md-12" (mouseover)="showpayment(true,'1')"
            (mouseout)="showpayment(false,'1')" id='16'>
            <div
                style="max-width: 100%; overflow: hidden; padding-bottom: 56.25%; position: relative;">

                <iframe
                    class="i-frame"
                    src="https://www.youtube.com/embed/RLUjhndQ-f8"
                    title="YouTube video player" frameborder="0"
                    allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
                    allowfullscreen></iframe>
            </div>
        </div> -->
                <div class="col-md-12 mt-2">

                    <label for="" class="mt-3" >With Payment QR, PayG is bridging the
                        gap between
                        technology
                        and
                        convenience, allowing your customers to complete transactions swiftly and
                        securely
                        using
                        the power of QR codes. With Payment QR, we're redefining the payment
                        experience,
                        making
                        it faster, safer, and more seamless than ever. No matter where you are or
                        what
                        you're
                        purchasing, our Payment QR feature empowers you to complete transactions
                        effortlessly,
                        ensuring a secure and efficient process for both merchants and
                        customers.</label>
                </div>
                <div class="col-md-12 mt-5" (mouseover)="showpayment(true,'3')" (mouseout)="showpayment(false,'3')"
                    id="18">
                    <h2 >Key Benefits of Payment QR: </h2>
                    <ul>
                        <li class="mt-3" >
                            <b>Instant Transactions:</b>&nbsp; Payment QR enables rapid transactions
                            with a
                            simple scan.
                        </li>
                        <li class="mt-3" >
                            <b>User-Friendly Experience: </b>&nbsp; Seamlessly integrated into
                            PayG’s
                            platform,
                            Payment QR offers a user-friendly experience for both customers and
                            merchants.
                        </li>
                        <li class="mt-3" >
                            <b>Enhanced Security:</b>&nbsp;Each QR code is encrypted, ensuring
                            secure
                            payment
                            processing and safeguarding sensitive information.
                        </li>
                        <li class="mt-3" >
                            <b>Anytime, Anywhere Payments:</b>&nbsp; Whether in-store, at events, or
                            online,
                            Payment QR empowers payments across various touchpoints.
                        </li>
                    </ul>
                </div>
                <div class="col-md-12 mt-5" (mouseover)="showpayment(true,'4')" (mouseout)="showpayment(false,'4')"
                    id="19">
                    <h2 >Get started with your PayG QR code to collect payments:
                    </h2>
                </div>
                <div class="col-md-12 mt-4">
                    <label for="" ><b>Step 1:</b> Sign in to your PayG merchant
                        account, if you are a
                        new user then register yourself with PayG. </label>
                    <br><img src="./assets/create1.png" alt="" width="40%" height="80%" class="mt-2">
                </div>
                <div class="col-md-12 mt-4">
                    <label for="" ><b>Step 2:</b> On your merchant dashboard, go to
                        the left sidebar
                        menu and click on “My QR Code”. </label>
                    <br><img src="./assets/qr1.png" alt="" width="40%" height="80%" class="mt-2">
                </div>
                <div class="col-md-12 mt-4">
                    <label for="" ><b>Step 3:</b>Merchants can download it and share
                        it with their
                        customers to collect payments. Additionally, they have the flexibility to
                        set a custom amount based on their product. </label>
                    <br><img src="./assets/qr2.png" alt="" width="40%" height="80%" class="mt-2">
                </div>
            </div>
        </div>
    </div>
    <div class="col-md-4   hide-tbl content2 ">
        <div class="card crd p-4">
            <div class="row">
                <div class="col-md-12">
                    <h5 >
                        Table of Contents:
                    </h5>
                </div>
                <!-- <div class="col-md-12 mt-2">
            <a href="#16"> <div class="row">


                <div class="col-md-2"> <img src="./assets/video.svg" class="tab-icon intro"
                        alt=""> &nbsp;</div>
                <div class="col-md-10">

                    <span style="cursor: pointer;" class="videoHover"
                        [ngClass]="{'video':colors=='1'}" (click)="color('1')">
                        What is a Payment QR </span>
                </div>
            </div></a>
        </div> -->

                <div class="col-md-12 mt-2">
                    <a href="#17">
                        <div class="row">
                            <div class="col-md-2"> <img   src="./assets/edit.svg" class="tab-icon intro" alt="">
                                &nbsp;</div>
                            <div class="col-md-10">

                                <span style="cursor: pointer;" class="textHover" [ngClass]="{'text':colors=='2'}"
                                    (click)="color('2')" >
                                    What is a Payment QR? </span>
                            </div>
                        </div>
                    </a>
                </div>
                <div class="col-md-12 mt-2">
                    <a href="#18">
                        <div class="row">
                            <div class="col-md-2"> <img   src="./assets/edit.svg" class="tab-icon intro" alt="">
                                &nbsp;</div>
                            <div class="col-md-10">

                                <span style="cursor: pointer;" class="textHover" [ngClass]="{'text':colors=='3'}"
                                    (click)="color('3')" >Benefits
                                    of
                                    Payment QR </span>
                            </div>
                        </div>
                    </a>
                </div>
                <div class="col-md-12 mt-2">
                    <a href="#19">
                        <div class="row">
                            <div class="col-md-2"> <img   src="./assets/edit.svg" class="tab-icon intro" alt="">
                                &nbsp;</div>
                            <div class="col-md-10">

                                <span style="cursor: pointer;" class="textHover" [ngClass]="{'text':colors=='4'}"
                                    (click)="color('4')" >How to get
                                    started? </span>
                            </div>
                        </div>
                    </a>
                </div>

            </div>
        </div>
    </div>
    <div class="col-md-9 hide ft-9">
        <hr>
        <div class=" row crd">
            <div class="col-md-8">
                <a [routerLink]="['/pay-button']"> <button class="btn btn-color" (click)="menues('Pay Button')"> <img
                        src="./assets/Arrow 3.svg" alt="">&nbsp;&nbsp;Pay Button
                </button></a>
              
            </div>
            <div class="col-md-4    ">
                <a [routerLink]="['/invoice']">  <button class="btn btn-color" (click)="menues('Invoice')">Invoice
                    &nbsp;<img src="./assets/Arrow 2 1.svg" alt=""></button></a>
               
            </div>
        </div>
    </div>
</div>